module.exports = __webpack_public_path__ + "img/ep-K-dosis.ec26abd1.jpg";